import React from 'react'
import {AiOutlineCopyright} from 'react-icons/ai'
import {AiOutlineMail} from 'react-icons/ai'
import {RiLinkedinFill, RiInstagramFill, RiFacebookFill,RiPhoneFill, RiMapPinFill, RiMailFill} from 'react-icons/ri'
import { Link } from 'react-router-dom'


const Testimonial = () => {
  return (

    <div id='testimonials' className='flex w-full items-center font-Lato container mx-auto px-4 justify-center text-white mb-4'>
        <div className='flex flex-col items-center justify-center'>
           <h3 className="text-2xl font-bold text-center mb-8 text-[#008024]"><u>Testimonials</u></h3>
           
            <div className="mt-8 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
              
          <div className='card'>
<img alt='BDK' src='images/Testimony1.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony2.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony3.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony4.jpeg' className='img-fluid cursor-pointer' />
          </div>

          <div className='card'>
<img alt='BDK' src='images/Testimony5.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony6.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony7.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony8.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony9.jpeg' className='img-fluid cursor-pointer' />
          </div>
          <div className='card'>
<img alt='BDK' src='images/Testimony10.jpeg' className='img-fluid cursor-pointer' />
          </div>
 

            </div>
        </div>
    </div>
  )
}

export default Testimonial